<template>
  <v-card-text>
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="headline">{{ $tc('dashboard.menu.raceDetails.race_visits') }}</v-list-item-title>
        <v-list-item-subtitle
          class="display-3"
          v-if="stats != null"
        >{{ stats.android + stats.iphone + stats.browser }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="headline">{{ $tc('dashboard.menu.raceDetails.mob_users') }}</v-list-item-title>
        <v-list-item-subtitle
          class="display-3"
          v-if="stats != null"
        >{{ stats.android + stats.iphone }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="headline">{{ $tc('dashboard.menu.raceDetails.pc_users') }}</v-list-item-title>
        <v-list-item-subtitle class="display-3" v-if="stats != null">{{ stats.browser }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card-text>
</template>
<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import AsyncComputed from "vue-async-computed";
import Vue from "vue";

Vue.use(AsyncComputed);

export default {
  mixins: [apiCalls],
  data() {
    return {
      stats: []
    };
  },
  asyncComputed: {
    stats: async function() {
      var response = await this.api(
        "get",
        "/api/v1/promoter/race/getStat/" + this.$route.params.id
      );
      return response.message[0];
    }
  }
};
</script>